import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './assets/styles/global.css'
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import ScrollTop from './layouts/website/ScrollTop';

ReactDOM.render(
  <BrowserRouter>
    <ScrollTop />
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
